import Vue from 'vue';
import applyConverters from 'axios-case-converter';
import axios from 'axios';

import { storage } from '@/utils/storage';

const instance = applyConverters(
  axios.create({
    //  ---REPLACE AFTER DEV---
    withCredentials: true,
    baseURL: process.env.VUE_APP_API_ENDPOINT,
    headers: {
      'Content-Type': 'application/json',
    },
  }) as any // eslint-disable-line @typescript-eslint/no-explicit-any
);

instance.interceptors.request.use((config) => {
  if (storage.getItem('OPW_TOKEN')) {
    config.headers.Authorization = `Bearer ${storage.getItem('OPW_TOKEN')}`;
  }
  return config;
});

Vue.prototype.$http = instance;
export default instance;
